import { render, staticRenderFns } from "./out-link.vue?vue&type=template&id=bf00daac&scoped=true"
import script from "./out-link.vue?vue&type=script&lang=js"
export * from "./out-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf00daac",
  null
  
)

export default component.exports